import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { EMPTY, Subscription } from 'rxjs';
import { EventsService } from 'src/app/services/events-service/events.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { Router, ActivatedRoute } from '@angular/router';
import { CenterAlertApplication } from 'src/app/models/center-model/center-alert-application.model';
import { CenterAlertContact } from 'src/app/models/center-model/center-alert-contact.model';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';
import { CenterAlertIotDevice } from 'src/app/models/center-model/center-alert-iot-device.model';
import { CentersCentersService } from 'src/app/services/centers-services/centers-centers-service/centers-centers.service';

@Component({
  selector: 'app-events-new-event-creation-card',
  templateUrl: './events-new-event-creation-card.component.html',
  styleUrls: ['./events-new-event-creation-card.component.scss']
})
export class EventsNewEventCreationCardComponent implements OnInit, OnDestroy {

  @Input() centerList;
  applications;
  iotDevices;
  selectedApplications;
  selectedIotDevices;
  mailProviders;
  alertContacts;
  availableDesks;
  alertOccupationItems = [];
  showButton: boolean;
  JSON;
  maintenanceAlerts = [
    { type: ['LOW_BATERY', 'DEVICE_BATTERY_LEVEL'], value: false },
    { type: ['DISCONNECTED', 'SOCKET_STATUS'], value: false },
    { type: ['PAPER_NOT_PRESENT', 'PRINTER_STATUS'], value: false },
    { type: ['DISCONNECTED', 'PRINTER_STATUS'], value: false }
  ];
  basicDataForm = new FormGroup({
    reviewAutomatic: new FormControl(true),
    name: new FormControl(null, Validators.required),
    selectedCenter: new FormControl(null, Validators.required),
    contactForm: new FormGroup({
      contactName: new FormControl(null, Validators.required),
      contactMail: new FormControl(null, Validators.required),
      contactPhone: new FormControl(null, Validators.required)
    }),
    checkboxesForm: new FormGroup({}),
    occupancyForm: new FormGroup({
      selectedDesk: new FormControl(null),
      deskCapacityLimit: new FormControl(null)
    }),
    selectedMailProvider: new FormControl(null, Validators.required)
  });
  getAlertApplicationsSubscription: Subscription;
  getAlertIotSubscription: Subscription;
  addNewAlertSubscription: Subscription;
  getCompanyMailProvidersSubscription: Subscription;
  getAlertDesksSubscription: Subscription;

  constructor(private eventsService: EventsService,
              private spinnerService: SpinnerService,
              private centerservice: CentersCentersService,
              private router: Router,
              private desksTurnsService: DesksTurnsService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService) {
                this.showButton = true;
                this.JSON = JSON;
                this.selectedApplications = new Array<CenterAlertApplication>();
                this.selectedIotDevices = new Array<CenterAlertIotDevice>();
                this.alertContacts = new Array<CenterAlertContact>();
  }

  ngOnInit() {
    this.createForm();
  }

  public addOccupancy() {
    if (this.basicDataForm.get('occupancyForm').get('selectedDesk').value && this.basicDataForm.get('occupancyForm').get('deskCapacityLimit').value) {
      this.alertOccupationItems.push({ deskInternalId: this.basicDataForm.get('occupancyForm').get('selectedDesk').value.internalId, deskName: this.basicDataForm.get('occupancyForm').get('selectedDesk').value.deskName, deskCapacityLimit: this.basicDataForm.get('occupancyForm').get('deskCapacityLimit').value});
    } else {
      this.snackbarService.open('', 'error');
    }
  }

  public deleteOccupancy(index) {
    this.alertOccupationItems.splice(index, 1);
  }

  public addNewAlert() {
    const validation = this.validateForm();
    if (validation === true) {
      this.showButton = false;
      this.spinnerService.show('alert-new-spinner');
      this.addNewAlertSubscription = this.eventsService.addNewAlert(this.basicDataForm.get('reviewAutomatic').value, this.basicDataForm.get('name').value, this.getSelectedCenterInternalId(),  this.parseFormValues(this.basicDataForm.get('checkboxesForm')), this.alertContacts, this.selectedApplications, this.selectedIotDevices, this.parseOccupationValues(this.alertOccupationItems), this.getSelectedMailProvider()).pipe(
        tap(o => this.spinnerService.hide('alert-new-spinner')),
        tap(o => this.snackbarService.open('events-page.snackbar messages.add event success', 'success')),
        tap(o => this.router.navigate(['../events'], {relativeTo: this.activatedRoute.parent})),
        catchError(error => { this.showButton = true; this.spinnerService.hide('alert-new-spinner'); this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
      ).subscribe();
    } else {
      this.showButton = true;
      this.spinnerService.hide('alert-new-spinner');
      this.snackbarService.open(validation, 'error');
    }
  }

  public parseOccupationValues(alertOccupationItems) {
    return this.alertOccupationItems.map(
      (ao) => {
        return { deskInternalId: ao.deskInternalId, deskCapacityLimit: ao.deskCapacityLimit };
      }
    );
  }

  public validateForm() {
    if (!this.basicDataForm.get('name').valid) {
      return 'events-page.snackbar messages.event name required error';
    } else if (!this.basicDataForm.get('selectedCenter').valid) {
      return 'events-page.snackbar messages.selected center required error';
    } else if (!this.basicDataForm.get('selectedMailProvider').valid) {
      return 'events-page.snackbar messages.selected email provider required error';
    } else {
      return true;
    }
  }

  public addContact() {
    const valid = this.validateContactsForm();
    if (valid === true) {
      const contact = new CenterAlertContact(null, this.basicDataForm.get('contactForm').get('contactMail').value, this.basicDataForm.get('contactForm').get('contactName').value, this.basicDataForm.get('contactForm').get('contactPhone').value);
      this.alertContacts.push(contact);
      this.resetContactForm();
    } else {
      this.snackbarService.open(valid, 'error');
    }
  }

  public resetContactForm() {
    this.basicDataForm.get('contactForm').patchValue({
      contactName: null,
      contactMail: null,
      contactPhone: null
    });
  }

  public validateContactsForm() {
    if (!this.basicDataForm.get('contactForm').get('contactName').valid) {
      return 'events-page.snackbar messages.contact name required error';
    } else if (!this.basicDataForm.get('contactForm').get('contactMail').valid && !this.basicDataForm.get('contactForm').get('contactPhone').valid) {
      return 'events-page.snackbar messages.email or sms required error';
    } else {
      return true;
    }
  }

  public deleteContact(index) {
    this.alertContacts.splice(index, 1);
  }

  public getAlertApplications() {
    this.getAlertApplicationsSubscription = this.eventsService.getAlertApplications(this.getSelectedCenterInternalId()).pipe(
      tap(o => this.applications = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getAlertIotDevices() {
    this.getAlertIotSubscription = this.centerservice.getIotDevices(this.getSelectedCenterInternalId()).pipe(
      tap(o => this.iotDevices = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getCompanyMailProviders() {
    this.getCompanyMailProvidersSubscription = this.eventsService.getCompanyMailProviders(this.getSelectedCenterInternalId()).pipe(
      tap(o => this.mailProviders = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public getAlertDesks() {
    this.getAlertDesksSubscription = this.desksTurnsService.getDesks().subscribe(
      (res) => {
        this.availableDesks = (res as Array<any>).filter((ad) => ad.CenterInternalId === this.getSelectedCenterInternalId());
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public duallistboxOutputEventReceiver(selectedApplications) {
    const aux = new Array();
    for (const d of selectedApplications) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedApplications = aux;
    }
  }

  public duallistboxIotOutputEventReceiver(selectedIotDevices) {
    const aux = new Array();
    for (const d of selectedIotDevices) {
      aux.push(d[1]._data);
    }
    if (aux) {
      this.selectedIotDevices = aux;
    }
  }

  public getSelectedCenterInternalId() {
    if (this.centerList.length === 1) {
      return this.centerList[0].InternalId;
    } else {
      if (this.basicDataForm.get('selectedCenter').value) {
        return this.basicDataForm.get('selectedCenter').value.InternalId;
      } else {
        return null;
      }
    }
  }

  public getSelectedMailProvider() {
    if (this.mailProviders.length === 1) {
      return this.mailProviders[0];
    } else {
      if (this.basicDataForm.get('selectedMailProvider').value) {
        return this.basicDataForm.get('selectedMailProvider').value;
      } else {
        return null;
      }
    }
  }

  public setPreselected(op1, op2) {
    if (op1 && op2) {
      return op1.InternalId === op2.InternalId;
    }
  }

  private createForm() {
    this.maintenanceAlerts.forEach(
      (ma) => {
        (this.basicDataForm.get('checkboxesForm') as FormGroup).addControl(JSON.stringify(ma.type), new FormControl(ma.value, Validators.required));
      }
    );
  }

  private parseFormValues(form) {
    const activeControls = [];
    Object.entries(form.controls).forEach(
      (control) => {
        if (control[1]['value'] === true) {
          activeControls.push({ alertValue: JSON.parse(control[0])[0], alertType: JSON.parse(control[0])[1] });
        }
      }
    );
    return activeControls;
  }

  public filterOnlyPositiveIntegers(e) {
    return e.charCode > 48;
  }

  ngOnDestroy() {
    if (this.getAlertApplicationsSubscription) { this.getAlertApplicationsSubscription.unsubscribe(); }
    if (this.getAlertIotSubscription) { this.getAlertIotSubscription.unsubscribe(); }
    if (this.addNewAlertSubscription) { this.addNewAlertSubscription.unsubscribe(); }
    if (this.getCompanyMailProvidersSubscription) { this.getCompanyMailProvidersSubscription.unsubscribe(); }
    if (this.getAlertDesksSubscription) { this.getAlertDesksSubscription.unsubscribe(); }
  }
}
